import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import DriversAnalytics from '@/components/drivers/DriversAnalytics';
import DriversRecords from '@/components/drivers/DriversRecords';
import DriverSheet from '@/components/drivers/DriverSheet';

export default function Drivers() {
  const [sheetOpen, setSheetOpen] = useState(false);
  const [selectedDriverId, setSelectedDriverId] = useState<number | null>(null);

  const openCreateSheet = () => {
    setSelectedDriverId(null);
    setSheetOpen(true);
  };

  const openViewSheet = (driverId: number) => {
    setSelectedDriverId(driverId);
    setSheetOpen(true);
  };

  return (
    <div className="space-y-6 animate-fade-in px-4 sm:px-6 lg:px-8 pt-6">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-4xl font-semibold tracking-tight mb-2">Drivers</h1>
          <p className="text-muted-foreground">Manage driver profiles and contract assignments.</p>
        </div>
        <Button onClick={openCreateSheet}>
          <Plus className="h-4 w-4 mr-1" />
          Add Driver
        </Button>
      </div>

      <Tabs defaultValue="analytics" className="space-y-6">
        <TabsList>
          <TabsTrigger value="analytics">Analytics</TabsTrigger>
          <TabsTrigger value="records">Records</TabsTrigger>
        </TabsList>

        <TabsContent value="analytics">
          <DriversAnalytics />
        </TabsContent>

        <TabsContent value="records">
          <DriversRecords onDriverClick={openViewSheet} />
        </TabsContent>
      </Tabs>

      <DriverSheet
        open={sheetOpen}
        onOpenChange={setSheetOpen}
        driverId={selectedDriverId}
      />
    </div>
  );
}
